import { render } from "./AboutBody.vue?vue&type=template&id=0b66fb34&scoped=true"
import script from "./AboutBody.vue?vue&type=script&lang=js"
export * from "./AboutBody.vue?vue&type=script&lang=js"

import "./AboutBody.vue?vue&type=style&index=0&id=0b66fb34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b66fb34"

export default script